import React from 'react';
import GenericSvgIcon from "./GenericSvgIcon";
import IconType from "@/types/Icon.type";

const IconRating = (props: IconType) => {
    const {
        width = '16',
        height = '16',
        fill = '#7e00d9',
        stroke = '#7e00d9',
        viewBox = '0 0 16 16',
        title = 'IconRating',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            {...props}
            svgIconPath={(
                <path
                    d="m6.97225648 1.19088015.72828304 1.93929083c.22158333.63304298.62909896 1.16320726 1.1488782 1.53745098.52201651.37585456 1.15726508.59444344 1.83112178.60203689l2.1744843.02450351-1.6712511 1.21069855c-.5593874.40523501-.9568962.96726497-1.1618227 1.59242329-.20492642.62515832-.21727048 1.313445-.0063283 1.9711935l.6211147 1.9367263-1.8214295-1.2573022c-.54625993-.377074-1.18064185-.5656388-1.81503827-.5656876s-1.26880733.1884185-1.81512523.5654085l-1.82193158 1.2572352.62116649-1.9368878c.21094217-.65774847.19859811-1.34603515-.00632833-1.97119347s-.60243527-1.18718828-1.16182265-1.59242329l-1.67125117-1.21069855 2.17448434-.02450351c.67385665-.00759345 1.30910527-.22618233 1.83112178-.60203689.52201651-.37585457.93080091-.90897483 1.15172913-1.54563107z"
                    fill={fill} stroke={stroke} stroke-width="1.3" transform="translate(1 1.5)"
                />

            )}
        />
    );
};

export default IconRating;
